import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Route, Routes as Switch } from "react-router-dom";

import Dashboard from "../../views/dashboard";

import Spinner from "../../layout/spinner";

class Routes extends React.Component {
  componentDidUpdate(oldProps) {

  }
  
  render() {
    if (!this.props.auth.authenticated) {
      const loginUrl = localStorage.getItem("loginUrl") || "/";
      window.location.replace(loginUrl);
      return;
    }
  
    return (
      <>
        {this.props.auth.loading ? <Spinner /> : <></>}
        <Switch>
          <Route exact={false} path="/*" element={<Dashboard />}></Route>
        </Switch>
      </>
    );

  }

}

Dashboard.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    });
};

export default connect(mapStateToProps)(Routes);
